// central place for generic/shared functionality across Partners

import {getRiskPartner, isAuthorized, isEntitled} from '../../shared/reducers/user';
import history from '../../history';
import store, {_openModal} from '../../shared/store';
import qs from 'query-string';

export const calculateNewWindowDimensions = (data, partnerName) => {
  const w = 500;
  const h = 570;
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : Screen.left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : Screen.top;
  let width;
  let height;
  if (window.innerWidth) {
    width = window.innerWidth;
  } else if (document.documentElement.clientWidth) {
    width = document.documentElement.clientWidth;
  } else {
    width = Screen.width;
  }
  if (window.innerHeight) {
    height = window.innerHeight;
  } else if (document.documentElement.clientHeight) {
    height = document.documentElement.clientHeight;
  } else {
    height = Screen.height;
  }

  const left = ((width / 2) - (w / 2)) + dualScreenLeft;
  const top = ((height / 2) - (h / 2)) + dualScreenTop;
  return window.open(
    data,
    partnerName,
    'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
  );
};

export const openNewTab = (url) => {
  const newWindow = window.open(url, 'noopener,noreferrer');
  if (newWindow) window.opener = null;
};

export const getSFSURI = (profile) => {
  if (profile.sfsID) {
    return '/engage/sfs/sso';
  }
  if (isAuthorized(['FIRMMGR'])) {
    return '/engage/sfs/firmConfigure';
  }
  return '/engage/sfs/individualConfigure';
};

export const getPartnerURI = (partner, isConnected, profile) => {
  switch (partner) {
    case 'billFin':
      return `/engage/${partner}`;
    case 'redtail':
    case 'wealthbox':
      if (isConnected) return `/engage/${partner}`;
      return `/engage/${partner}/login`;
    case 'rightCapital':
      return '/analyze/financialPlanning';
    case 'riskalyze':
    case 'totum':
    case 'stratifi':
      if (isConnected && isEntitled([
        {group: 'risk', feature: 'riskalyze', access: 'r'},
        {group: 'risk', feature: 'totum', access: 'r'},
        {group: 'risk', feature: 'stratifi', access: 'r'},
      ])) {
        return `/analyze/risk/${partner}`;
      }
      return `/analyze/risk/${partner}/setup`;
    case 'emoney':
    case 'mgp':
      return `/analyze/financialPlanning/${partner}`;
    case 'sfs':
      // case 'salesforce': // Eventually implement salesforce sso, currently doesn't work in v2
      return getSFSURI(profile);
    case 'stockCalc':
      return `/analyze/research/${partner}`;
    case 'riab':
      return profile.riab ? '/riab' : '/riab/login';
    default:
      return '/';
  }
};

export const openRiskPartner = (context) => {
  const partner = getRiskPartner();
  const isRiskEntitled = () => {
    if (!isEntitled([{group: 'risk', feature: partner, access: 'c'}])) {
      return null;
    }
  };

  if (partner) {
    isRiskEntitled();

    if (partner === 'totum' && (context && !context.totumID)) {
      delete context.totumID;
    }
    return history.push(`${getPartnerURI(partner, true)}?${qs.stringify(context)}`);
  }

  if (isEntitled([{group: 'partners', feature: 'totum', access: 'c'}, {group: 'partners', access: 'c'}])) {
    return history.push('/analyze/risk');
  }
  return store.dispatch(_openModal({
    type: 'MessageModal',
    title: 'Risk Partner',
    body: 'Please sign up with a Risk Analysis Partner.',
  }));
};
